!(function(e, t, n) {
  function r(e, t) {
    return typeof e === t;
  }
  function o() {
    var e, t, n, o, i, a, s;
    for (var A in b)
      if (b.hasOwnProperty(A)) {
        if (
          ((e = []),
          (t = b[A]),
          t.name &&
            (e.push(t.name.toLowerCase()),
            t.options && t.options.aliases && t.options.aliases.length))
        )
          for (n = 0; n < t.options.aliases.length; n++)
            e.push(t.options.aliases[n].toLowerCase());
        for (o = r(t.fn, "function") ? t.fn() : t.fn, i = 0; i < e.length; i++)
          (a = e[i]),
            (s = a.split(".")),
            1 === s.length
              ? (Modernizr[s[0]] = o)
              : (!Modernizr[s[0]] ||
                  Modernizr[s[0]] instanceof Boolean ||
                  (Modernizr[s[0]] = new Boolean(Modernizr[s[0]])),
                (Modernizr[s[0]][s[1]] = o)),
            w.push((o ? "" : "no-") + s.join("-"));
      }
  }
  function i(e) {
    var t = k.className,
      n = Modernizr._config.classPrefix || "";
    if ((Q && (t = t.baseVal), Modernizr._config.enableJSClass)) {
      var r = new RegExp("(^|\\s)" + n + "no-js(\\s|$)");
      t = t.replace(r, "$1" + n + "js$2");
    }
    Modernizr._config.enableClasses &&
      ((t += " " + n + e.join(" " + n)),
      Q ? (k.className.baseVal = t) : (k.className = t));
  }
  function a(e, t) {
    if ("object" == typeof e) for (var n in e) U(e, n) && a(n, e[n]);
    else {
      e = e.toLowerCase();
      var r = e.split("."),
        o = Modernizr[r[0]];
      if ((2 == r.length && (o = o[r[1]]), "undefined" != typeof o))
        return Modernizr;
      (t = "function" == typeof t ? t() : t),
        1 == r.length
          ? (Modernizr[r[0]] = t)
          : (!Modernizr[r[0]] ||
              Modernizr[r[0]] instanceof Boolean ||
              (Modernizr[r[0]] = new Boolean(Modernizr[r[0]])),
            (Modernizr[r[0]][r[1]] = t)),
        i([(t && 0 != t ? "" : "no-") + r.join("-")]),
        Modernizr._trigger(e, t);
    }
    return Modernizr;
  }
  function s() {
    return "function" != typeof t.createElement
      ? t.createElement(arguments[0])
      : Q
      ? t.createElementNS.call(t, "http://www.w3.org/2000/svg", arguments[0])
      : t.createElement.apply(t, arguments);
  }
  function A() {
    var e = t.body;
    return e || ((e = s(Q ? "svg" : "body")), (e.fake = !0)), e;
  }
  function l(e, n, r, o) {
    var i,
      a,
      l,
      u,
      d = "modernizr",
      c = s("div"),
      f = A();
    if (parseInt(r, 10))
      for (; r--; )
        (l = s("div")), (l.id = o ? o[r] : d + (r + 1)), c.appendChild(l);
    return (
      (i = s("style")),
      (i.type = "text/css"),
      (i.id = "s" + d),
      (f.fake ? f : c).appendChild(i),
      f.appendChild(c),
      i.styleSheet
        ? (i.styleSheet.cssText = e)
        : i.appendChild(t.createTextNode(e)),
      (c.id = d),
      f.fake &&
        ((f.style.background = ""),
        (f.style.overflow = "hidden"),
        (u = k.style.overflow),
        (k.style.overflow = "hidden"),
        k.appendChild(f)),
      (a = n(c, e)),
      f.fake
        ? (f.parentNode.removeChild(f), (k.style.overflow = u), k.offsetHeight)
        : c.parentNode.removeChild(c),
      !!a
    );
  }
  function u(e, t) {
    return !!~("" + e).indexOf(t);
  }
  function d(e) {
    return e
      .replace(/([a-z])-([a-z])/g, function(e, t, n) {
        return t + n.toUpperCase();
      })
      .replace(/^-/, "");
  }
  function c(e, t) {
    return function() {
      return e.apply(t, arguments);
    };
  }
  function f(e, t, n) {
    var o;
    for (var i in e)
      if (e[i] in t)
        return n === !1
          ? e[i]
          : ((o = t[e[i]]), r(o, "function") ? c(o, n || t) : o);
    return !1;
  }
  function p(e) {
    return e
      .replace(/([A-Z])/g, function(e, t) {
        return "-" + t.toLowerCase();
      })
      .replace(/^ms-/, "-ms-");
  }
  function g(t, n, r) {
    var o;
    if ("getComputedStyle" in e) {
      o = getComputedStyle.call(e, t, n);
      var i = e.console;
      if (null !== o) r && (o = o.getPropertyValue(r));
      else if (i) {
        var a = i.error ? "error" : "log";
        i[a].call(
          i,
          "getComputedStyle returning null, its possible modernizr test results are inaccurate"
        );
      }
    } else o = !n && t.currentStyle && t.currentStyle[r];
    return o;
  }
  function m(t, r) {
    var o = t.length;
    if ("CSS" in e && "supports" in e.CSS) {
      for (; o--; ) if (e.CSS.supports(p(t[o]), r)) return !0;
      return !1;
    }
    if ("CSSSupportsRule" in e) {
      for (var i = []; o--; ) i.push("(" + p(t[o]) + ":" + r + ")");
      return (
        (i = i.join(" or ")),
        l(
          "@supports (" + i + ") { #modernizr { position: absolute; } }",
          function(e) {
            return "absolute" == g(e, null, "position");
          }
        )
      );
    }
    return n;
  }
  function v(e, t, o, i) {
    function a() {
      l && (delete G.style, delete G.modElem);
    }
    if (((i = r(i, "undefined") ? !1 : i), !r(o, "undefined"))) {
      var A = m(e, o);
      if (!r(A, "undefined")) return A;
    }
    for (
      var l, c, f, p, g, v = ["modernizr", "tspan", "samp"];
      !G.style && v.length;

    )
      (l = !0), (G.modElem = s(v.shift())), (G.style = G.modElem.style);
    for (f = e.length, c = 0; f > c; c++)
      if (
        ((p = e[c]),
        (g = G.style[p]),
        u(p, "-") && (p = d(p)),
        G.style[p] !== n)
      ) {
        if (i || r(o, "undefined")) return a(), "pfx" == t ? p : !0;
        try {
          G.style[p] = o;
        } catch (y) {}
        if (G.style[p] != g) return a(), "pfx" == t ? p : !0;
      }
    return a(), !1;
  }
  function y(e, t, n, o, i) {
    var a = e.charAt(0).toUpperCase() + e.slice(1),
      s = (e + " " + z.join(a + " ") + a).split(" ");
    return r(t, "string") || r(t, "undefined")
      ? v(s, t, o, i)
      : ((s = (e + " " + P.join(a + " ") + a).split(" ")), f(s, t, n));
  }
  function h(e, t, r) {
    return y(e, n, n, t, r);
  }
  var w = [],
    b = [],
    T = {
      _version: "3.6.0",
      _config: {
        classPrefix: "",
        enableClasses: !0,
        enableJSClass: !0,
        usePrefixes: !0
      },
      _q: [],
      on: function(e, t) {
        var n = this;
        setTimeout(function() {
          t(n[e]);
        }, 0);
      },
      addTest: function(e, t, n) {
        b.push({ name: e, fn: t, options: n });
      },
      addAsyncTest: function(e) {
        b.push({ name: null, fn: e });
      }
    },
    Modernizr = function() {};
  (Modernizr.prototype = T),
    (Modernizr = new Modernizr()),
    Modernizr.addTest("customelements", "customElements" in e),
    Modernizr.addTest(
      "customevent",
      "CustomEvent" in e && "function" == typeof e.CustomEvent
    ),
    Modernizr.addTest("geolocation", "geolocation" in navigator),
    Modernizr.addTest("history", function() {
      var t = navigator.userAgent;
      return (-1 === t.indexOf("Android 2.") &&
        -1 === t.indexOf("Android 4.0")) ||
        -1 === t.indexOf("Mobile Safari") ||
        -1 !== t.indexOf("Chrome") ||
        -1 !== t.indexOf("Windows Phone") ||
        "file:" === location.protocol
        ? e.history && "pushState" in e.history
        : !1;
    }),
    Modernizr.addTest("postmessage", "postMessage" in e),
    Modernizr.addTest("serviceworker", "serviceWorker" in navigator);
  var C = !1;
  try {
    C = "WebSocket" in e && 2 === e.WebSocket.CLOSING;
  } catch (x) {}
  Modernizr.addTest("websockets", C);
  var B = "CSS" in e && "supports" in e.CSS,
    S = "supportsCSS" in e;
  Modernizr.addTest("supports", B || S),
    Modernizr.addTest("picture", "HTMLPictureElement" in e),
    Modernizr.addTest("lowbandwidth", function() {
      var e = navigator.connection || { type: 0 };
      return 3 == e.type || 4 == e.type || /^[23]g$/.test(e.type);
    }),
    Modernizr.addTest("localstorage", function() {
      var e = "modernizr";
      try {
        return localStorage.setItem(e, e), localStorage.removeItem(e), !0;
      } catch (t) {
        return !1;
      }
    }),
    Modernizr.addTest("webworkers", "Worker" in e);
  var E = T._config.usePrefixes
    ? " -webkit- -moz- -o- -ms- ".split(" ")
    : ["", ""];
  T._prefixes = E;
  var k = t.documentElement,
    Q = "svg" === k.nodeName.toLowerCase(),
    _ = "Moz O ms Webkit",
    P = T._config.usePrefixes ? _.toLowerCase().split(" ") : [];
  T._domPrefixes = P;
  var U;
  !(function() {
    var e = {}.hasOwnProperty;
    U =
      r(e, "undefined") || r(e.call, "undefined")
        ? function(e, t) {
            return t in e && r(e.constructor.prototype[t], "undefined");
          }
        : function(t, n) {
            return e.call(t, n);
          };
  })(),
    (T._l = {}),
    (T.on = function(e, t) {
      this._l[e] || (this._l[e] = []),
        this._l[e].push(t),
        Modernizr.hasOwnProperty(e) &&
          setTimeout(function() {
            Modernizr._trigger(e, Modernizr[e]);
          }, 0);
    }),
    (T._trigger = function(e, t) {
      if (this._l[e]) {
        var n = this._l[e];
        setTimeout(function() {
          var e, r;
          for (e = 0; e < n.length; e++) (r = n[e])(t);
        }, 0),
          delete this._l[e];
      }
    }),
    Modernizr._q.push(function() {
      T.addTest = a;
    }),
    Modernizr.addAsyncTest(function() {
      var e = new Image();
      (e.onload = e.onerror = function() {
        a("jpeg2000", 1 == e.width);
      }),
        (e.src =
          "data:image/jp2;base64,/0//UQAyAAAAAAABAAAAAgAAAAAAAAAAAAAABAAAAAQAAAAAAAAAAAAEBwEBBwEBBwEBBwEB/1IADAAAAAEAAAQEAAH/XAAEQED/ZAAlAAFDcmVhdGVkIGJ5IE9wZW5KUEVHIHZlcnNpb24gMi4wLjD/kAAKAAAAAABYAAH/UwAJAQAABAQAAf9dAAUBQED/UwAJAgAABAQAAf9dAAUCQED/UwAJAwAABAQAAf9dAAUDQED/k8+kEAGvz6QQAa/PpBABr994EAk//9k=");
    }),
    Modernizr.addAsyncTest(function() {
      function e(e, t, n) {
        function r(t) {
          var r = t && "load" === t.type ? 1 == o.width : !1,
            i = "webp" === e;
          a(e, i && r ? new Boolean(r) : r), n && n(t);
        }
        var o = new Image();
        (o.onerror = r), (o.onload = r), (o.src = t);
      }
      var t = [
          {
            uri:
              "data:image/webp;base64,UklGRiQAAABXRUJQVlA4IBgAAAAwAQCdASoBAAEAAwA0JaQAA3AA/vuUAAA=",
            name: "webp"
          },
          {
            uri:
              "data:image/webp;base64,UklGRkoAAABXRUJQVlA4WAoAAAAQAAAAAAAAAAAAQUxQSAwAAAABBxAR/Q9ERP8DAABWUDggGAAAADABAJ0BKgEAAQADADQlpAADcAD++/1QAA==",
            name: "webp.alpha"
          },
          {
            uri:
              "data:image/webp;base64,UklGRlIAAABXRUJQVlA4WAoAAAASAAAAAAAAAAAAQU5JTQYAAAD/////AABBTk1GJgAAAAAAAAAAAAAAAAAAAGQAAABWUDhMDQAAAC8AAAAQBxAREYiI/gcA",
            name: "webp.animation"
          },
          {
            uri:
              "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAAAfQ//73v/+BiOh/AAA=",
            name: "webp.lossless"
          }
        ],
        n = t.shift();
      e(n.name, n.uri, function(n) {
        if (n && "load" === n.type)
          for (var r = 0; r < t.length; r++) e(t[r].name, t[r].uri);
      });
    });
  var R = (function() {
    function e(e, t) {
      var o;
      return e
        ? ((t && "string" != typeof t) || (t = s(t || "div")),
          (e = "on" + e),
          (o = e in t),
          !o &&
            r &&
            (t.setAttribute || (t = s("div")),
            t.setAttribute(e, ""),
            (o = "function" == typeof t[e]),
            t[e] !== n && (t[e] = n),
            t.removeAttribute(e)),
          o)
        : !1;
    }
    var r = !("onblur" in t.documentElement);
    return e;
  })();
  (T.hasEvent = R),
    Modernizr.addTest("pointerevents", function() {
      var e = !1,
        t = P.length;
      for (e = Modernizr.hasEvent("pointerdown"); t-- && !e; )
        R(P[t] + "pointerdown") && (e = !0);
      return e;
    });
  var D = function(e, t) {
    var n = !1,
      r = s("div"),
      o = r.style;
    if (e in o) {
      var i = P.length;
      for (o[e] = t, n = o[e]; i-- && !n; )
        (o[e] = "-" + P[i] + "-" + t), (n = o[e]);
    }
    return "" === n && (n = !1), n;
  };
  (T.prefixedCSSValue = D),
    Modernizr.addTest("audio", function() {
      var e = s("audio"),
        t = !1;
      try {
        (t = !!e.canPlayType),
          t &&
            ((t = new Boolean(t)),
            (t.ogg = e
              .canPlayType('audio/ogg; codecs="vorbis"')
              .replace(/^no$/, "")),
            (t.mp3 = e
              .canPlayType('audio/mpeg; codecs="mp3"')
              .replace(/^no$/, "")),
            (t.opus =
              e.canPlayType('audio/ogg; codecs="opus"') ||
              e.canPlayType('audio/webm; codecs="opus"').replace(/^no$/, "")),
            (t.wav = e
              .canPlayType('audio/wav; codecs="1"')
              .replace(/^no$/, "")),
            (t.m4a = (
              e.canPlayType("audio/x-m4a;") || e.canPlayType("audio/aac;")
            ).replace(/^no$/, "")));
      } catch (n) {}
      return t;
    }),
    Modernizr.addTest("webgl", function() {
      var t = s("canvas"),
        n =
          "probablySupportsContext" in t
            ? "probablySupportsContext"
            : "supportsContext";
      return n in t
        ? t[n]("webgl") || t[n]("experimental-webgl")
        : "WebGLRenderingContext" in e;
    }),
    Modernizr.addTest("csspositionsticky", function() {
      var e = "position:",
        t = "sticky",
        n = s("a"),
        r = n.style;
      return (
        (r.cssText = e + E.join(t + ";" + e).slice(0, -e.length)),
        -1 !== r.position.indexOf(t)
      );
    }),
    Modernizr.addAsyncTest(function() {
      var e,
        t,
        n,
        r = s("img"),
        o = "sizes" in r;
      !o && "srcset" in r
        ? ((t =
            "data:image/gif;base64,R0lGODlhAgABAPAAAP///wAAACH5BAAAAAAALAAAAAACAAEAAAICBAoAOw=="),
          (e =
            "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="),
          (n = function() {
            a("sizes", 2 == r.width);
          }),
          (r.onload = n),
          (r.onerror = n),
          r.setAttribute("sizes", "9px"),
          (r.srcset = e + " 1w," + t + " 8w"),
          (r.src = e))
        : a("sizes", o);
    }),
    Modernizr.addTest("srcset", "srcset" in s("img"));
  var O = (function() {
    var t = e.matchMedia || e.msMatchMedia;
    return t
      ? function(e) {
          var n = t(e);
          return (n && n.matches) || !1;
        }
      : function(t) {
          var n = !1;
          return (
            l(
              "@media " + t + " { #modernizr { position: absolute; } }",
              function(t) {
                n =
                  "absolute" ==
                  (e.getComputedStyle
                    ? e.getComputedStyle(t, null)
                    : t.currentStyle
                  ).position;
              }
            ),
            n
          );
        };
  })();
  T.mq = O;
  var z = ((T.testStyles = l), T._config.usePrefixes ? _.split(" ") : []);
  T._cssomPrefixes = z;
  var j = function(t) {
    var r,
      o = E.length,
      i = e.CSSRule;
    if ("undefined" == typeof i) return n;
    if (!t) return !1;
    if (
      ((t = t.replace(/^@/, "")),
      (r = t.replace(/-/g, "_").toUpperCase() + "_RULE"),
      r in i)
    )
      return "@" + t;
    for (var a = 0; o > a; a++) {
      var s = E[a],
        A = s.toUpperCase() + "_" + r;
      if (A in i) return "@-" + s.toLowerCase() + "-" + t;
    }
    return !1;
  };
  T.atRule = j;
  var I = { elem: s("modernizr") };
  Modernizr._q.push(function() {
    delete I.elem;
  });
  var G = { style: I.elem.style };
  Modernizr._q.unshift(function() {
    delete G.style;
  });
  T.testProp = function(e, t, r) {
    return v([e], n, t, r);
  };
  (T.testAllProps = y),
    (T.testAllProps = h),
    Modernizr.addTest("cssanimations", h("animationName", "a", !0)),
    Modernizr.addTest("backgroundcliptext", function() {
      return h("backgroundClip", "text");
    }),
    Modernizr.addTest("cssgridlegacy", h("grid-columns", "10px", !0)),
    Modernizr.addTest("cssgrid", h("grid-template-rows", "none", !0)),
    Modernizr.addTest("cssfilters", function() {
      if (Modernizr.supports) return h("filter", "blur(2px)");
      var e = s("a");
      return (
        (e.style.cssText = E.join("filter:blur(2px); ")),
        !!e.style.length && (t.documentMode === n || t.documentMode > 9)
      );
    }),
    Modernizr.addTest("flexbox", h("flexBasis", "1px", !0)),
    Modernizr.addTest("cssmask", h("maskRepeat", "repeat-x", !0)),
    Modernizr.addTest("variablefonts", h("fontVariationSettings"));
  var J = (T.prefixed = function(e, t, n) {
    return 0 === e.indexOf("@")
      ? j(e)
      : (-1 != e.indexOf("-") && (e = d(e)), t ? y(e, t, n) : y(e, "pfx"));
  });
  Modernizr.addTest("vibrate", !!J("vibrate", navigator)),
    Modernizr.addTest("backgroundblendmode", J("backgroundBlendMode", "text")),
    Modernizr.addTest("objectfit", !!J("objectFit"), {
      aliases: ["object-fit"]
    }),
    o(),
    i(w),
    delete T.addTest,
    delete T.addAsyncTest;
  for (var L = 0; L < Modernizr._q.length; L++) Modernizr._q[L]();
  e.Modernizr = Modernizr;
})(window, document);
